import React, {useRef} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {ICharThreadStep} from "../../_interfaces/iCharThreadStep";
import {s_char_threadsteps} from "../../_signals/s_char";
import {ThreadStepUpdate} from "../../_api/BEThreads";
import {useSignals} from "@preact/signals-react/runtime";

interface IProp {
    open: ICharThreadStep | null,
    isOpen: (open: boolean) => void
}

export default function ThreadStepEdit({open, isOpen}: IProp) {
    useSignals()
    const descRef = useRef<HTMLInputElement>(null);
    const nameRef = useRef<HTMLInputElement>(null);


    const savestep = () => {
        if (!open) return
        let threadsteps = s_char_threadsteps.value;

        threadsteps = threadsteps.map(ts => {
            if (ts.id === open.id) {
                ts.name = nameRef.current?.value ?? ts.name;
                ts.descr = descRef.current?.value ?? ts.descr
                ThreadStepUpdate(ts)
            }
            return ts
        })
        s_char_threadsteps.value = threadsteps

        isOpen(false)
    }


    return <Dialog open={!!open}>
        <DialogContent>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={open?.name}
                    inputRef={nameRef}
                    label="step name"
                />
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={open?.descr}
                    inputRef={descRef}
                    label="step desc"
                />
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => savestep()}><CheckIcon/></Button>
            <Button onClick={() => isOpen(false)}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>

}

